import { render } from "./DocUser.vue?vue&type=template&id=2ee2d596"
import script from "./DocUser.vue?vue&type=script&lang=js"
export * from "./DocUser.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__